import { useMutation } from "@apollo/client/react";
import { Box, IconicButton } from "@nulogy/components";
import { GridBox4, StyledInput } from "components/common/EditableListStyledComponents";
import FieldRow from "components/common/FieldRow";
import Form from "components/controls/Form";
import { insertTeardownTime } from "hooks/apollo/teardownTime/helpers/handleUpdateTeardownTimes";
import { CreateTeardownTime } from "hooks/apollo/teardownTime/teardownTime.gql";
import React from "react";
import DateTime from "utils/DateTime";

export default function CreateNewTeardownTime({ newTeardownTimeId, onRemoveNewTeardownTimeId }) {
  const [createTeardownTime] = useMutation(CreateTeardownTime);

  const handleCreate = ({ id, label, duration }) =>
    createTeardownTime({
      update: (proxy, { data: newData }) => {
        const newTeardownTime = newData.createTeardownTime.teardownTime;

        insertTeardownTime(newTeardownTime, proxy);
      },
      variables: { duration: DateTime.hoursToSeconds(duration), id, label },
    });

  return (
    <Form
      initialValues={{ duration: "", id: newTeardownTimeId, label: "" }}
      onAfterSave={() => onRemoveNewTeardownTimeId(newTeardownTimeId)}
      onSave={handleCreate}
    >
      {({ dirty }) => (
        <FieldRow marginBottom="0">
          <GridBox4>
            <StyledInput
              className="spec-create-teardown-time-label-input"
              data-testid="create-teardown-time-label-input"
              field="label"
              placeholder="Teardown Time"
            />
            <StyledInput
              className="spec-create-teardown-time-duration-input"
              data-testid="create-teardown-time-duration-input"
              field="duration"
              style={{ textAlign: "left" }}
              type="number"
            />
            <Box paddingTop="x1">
              <IconicButton className="spec-save-teardown-time-icon" disabled={!dirty} icon="check" type="submit">
                Save
              </IconicButton>
            </Box>
            <Box paddingTop="x1">
              <IconicButton icon="close" onClick={() => onRemoveNewTeardownTimeId(newTeardownTimeId)} type="button">
                Cancel
              </IconicButton>
            </Box>
          </GridBox4>
        </FieldRow>
      )}
    </Form>
  );
}
